document.querySelectorAll('.file-input').forEach(($parent) => {
  const $input = $parent.querySelector('.file-input__input');
  const $text = $parent.querySelector('.file-input__text');

  $text.dataset.initialText = $text.textContent;

  $input.addEventListener('change', () => {
    const fileName = $input.files.length > 1
      ? ($input.dataset.multipleText || '').replace('{count}', $input.files.length)
      : $input.value.split('\\').pop();

    $text.textContent = fileName || $text.dataset.initialText;
  });

  $input.addEventListener('focus', () => {
    $parent.classList.add('file-input--focus');
  });

  $input.addEventListener('blur', () => {
    $parent.classList.remove('file-input--focus');
  });
});
